import React from "react";
import { SearchMedWrapper } from "./searchMedicine.style";
import { Input } from "antd";

const DEBOUNCE_DELAY = 300;
const SearchMedicine = ({ onSearch, disabled }) => {
  const handleSearch = (value) => {
    onSearch(value);
  };
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const debounceSearch = debounce(handleSearch, DEBOUNCE_DELAY);
  return (
    <SearchMedWrapper>
      <Input
        allowClear
        onChange={(e) => debounceSearch(e.target.value)}
        placeholder="Search Medicine"
        disabled={disabled}
        size="large"
      />
    </SearchMedWrapper>
  );
};

export default SearchMedicine;
